import React, { useEffect } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next/useAnalyticsEvents';

import { useMetricsContext } from '../context/metrics';
import {
	ForgeUIEmbeddedMacroAnalyticsContext,
	type EmbeddedMacroParentType,
	type EmbeddedMacroType,
} from './ForgeUIEmbeddedMacroAnalyticsContext';
import { trackBodiedMacroEmbeddedContent } from './useForgeUiAnalyticsEvent';

type ForgeUIBodiedMacroEmbeddedContentAnalyticsProps = {
	children: React.ReactNode;
	contentId?: string;
	embeddedMacroParentType?: EmbeddedMacroParentType;
	embeddedMacroType?: EmbeddedMacroType;
	extensionKey?: string;
	isInline?: boolean;
	source?: string;
};

type EmbeddedMacroRenderedAnalyticsTriggerProps = {
	extensionKey?: string;
	source?: string;
};

const EmbeddedMacroRenderedAnalyticsTrigger = ({
	extensionKey,
	source,
}: EmbeddedMacroRenderedAnalyticsTriggerProps): null => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { page } = useMetricsContext();
	const analyticsSource = source ?? page;

	useEffect(() => {
		trackBodiedMacroEmbeddedContent(createAnalyticsEvent, {
			source: analyticsSource,
			extensionKey,
		});
	}, [analyticsSource, createAnalyticsEvent, extensionKey]);

	return null;
};

export const ForgeUIBodiedMacroEmbeddedContentAnalytics = ({
	children,
	contentId,
	embeddedMacroParentType = 'UIKit',
	embeddedMacroType = 'productMacroCore',
	extensionKey,
	isInline,
	source,
}: ForgeUIBodiedMacroEmbeddedContentAnalyticsProps): React.JSX.Element => {
	return (
		<ForgeUIEmbeddedMacroAnalyticsContext
			contentId={contentId}
			embeddedMacroParentType={embeddedMacroParentType}
			embeddedMacroType={embeddedMacroType}
			isInline={isInline}
		>
			<EmbeddedMacroRenderedAnalyticsTrigger extensionKey={extensionKey} source={source} />
			{children}
		</ForgeUIEmbeddedMacroAnalyticsContext>
	);
};
